export * from './cookie'

export const BACKEND_URL: string = import.meta.env.VITE_BACKEND_URL
export const FRONTEND_URL: string = import.meta.env.VITE_FRONTEND_URL
export const AUTH_BASE_PATH = 'auth'
